import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';
import gsap from 'gsap';

interface OptionsInterface {
	cssId: {
		anim?: {
			heHubAboutHeValuesHeaderCustomCls: string;
			heHubAboutHeValuesFadeCarouselWrapperCls: string;
			heHubAboutHeValuesHeliumImgCls: string;
		},

		heHubAboutHeValuesFadeCarouselArrowLeftId?: string;
		heHubAboutHeValuesFadeCarouselArrowRightId?: string;
		heHubAboutHeValuesFadeCarouselItemCls?: string;
		heHubAboutHeValuesFadeCarouselCls?: string;
		fadeCarouselItemActive?: string;
	},

	slug: string
}

class Values extends Module {

	publicVars: OptionsInterface;

	privateVars: {
		currentPage: number;
		maxPages: number;
		animating: boolean;
	} = {
		currentPage: 1,
		maxPages: 0,
		animating: false
	}

	constructor(options: OptionsInterface) {
		super('He Hub About He Values Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubAboutHeValuesHeaderCustomCls || '', 'he_hub_about_he_values', { animCls: 'animate__zoomIn', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubAboutHeValuesFadeCarouselWrapperCls || '', 'he_hub_about_he_values', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubAboutHeValuesHeliumImgCls || '', 'he_hub_about_he_values', { animCls: 'animate__fadeInRight25P', once: true});
	}

	bind() {
		this.msg('bind');

		if(this.publicVars.cssId.heHubAboutHeValuesFadeCarouselArrowLeftId) {
			const arrowLeft = document.querySelector(
				this.publicVars.cssId.heHubAboutHeValuesFadeCarouselArrowLeftId);

			if (arrowLeft) {
				arrowLeft.addEventListener('click', () => {
					this.handleArrowClick('left');
				});
			}
		}

		if(this.publicVars.cssId.heHubAboutHeValuesFadeCarouselArrowRightId) {
			const arrowRight = document.querySelector(
				this.publicVars.cssId.heHubAboutHeValuesFadeCarouselArrowRightId);

			if (arrowRight) {
				arrowRight.addEventListener('click', () => {
					this.handleArrowClick('right');
				});
			}
		}

		if(this.publicVars.cssId.heHubAboutHeValuesFadeCarouselItemCls) {
			const items = document.querySelectorAll(this.publicVars.cssId.heHubAboutHeValuesFadeCarouselItemCls);

			this.privateVars.maxPages = items.length;
		}
	}

	handleArrowClick(dir: 'left' | 'right') {

		if(this.privateVars.animating) {
			return;
		}

		let newPageNum: number;

		if(dir === 'left') {
			newPageNum = this.privateVars.currentPage > 1 ? this.privateVars.currentPage - 1 : this.privateVars.maxPages;
		} else {
			newPageNum = this.privateVars.currentPage < this.privateVars.maxPages ? this.privateVars.currentPage + 1 : 1;
		}

		const currentItem = document.querySelector(`${this.publicVars.cssId.heHubAboutHeValuesFadeCarouselItemCls}${this.privateVars.currentPage}`);
		const newItem = document.querySelector(`${this.publicVars.cssId.heHubAboutHeValuesFadeCarouselItemCls}${newPageNum}`);

		if(!this.publicVars.cssId.heHubAboutHeValuesFadeCarouselCls || !currentItem || !newItem) {
			this.errorMsg('Please setup correctly fade carousel');
			return;
		}

		this.privateVars.animating = true;

		const fadeCarouselAnim = gsap.to(this.publicVars.cssId.heHubAboutHeValuesFadeCarouselCls, {
			duration: 0.3,
			ease: 'power2.inOut',
			opacity: 0,
			scale: 1,
			onComplete: async () => {
				currentItem.classList.remove(this.publicVars.cssId?.fadeCarouselItemActive?.substring(1) || '');
				newItem.classList.add(this.publicVars.cssId?.fadeCarouselItemActive?.substring(1) || '');

				await fadeCarouselAnim.reverse();

				this.privateVars.animating = false;
				this.privateVars.currentPage = newPageNum;
			}
		})
	}
}

export default Values;